
export const SET_VISIBLE = 'SET_VISIBLE';
export const SET_ON_CHANGE = 'SET_ON_CHANGE';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';




